import classes from './Input.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SVGIcon from '../SVGIcon/SVGIcon';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';

const Input = forwardRef((props, forwardedRef) => {
  const {
    meta = {},
    input = {},
    placeholder,
    type,
    cleanable,
    className,
    disabled,
    readonly,
    showCopyButton,
    ...other
  } = props;

  const cn = classnames(
    classes.base,
    {
      [classes.error]: (meta.touched && meta.error) || meta.submitError,
      [classes.cleanable]: cleanable,
      [classes.disabled]: disabled,
      [classes.readonly]: readonly
    },
    className
  );

  const [copy, copied] = useCopyToClipboard();

  return (
    <div className={classes.container}>
      <input
        {...input}
        ref={forwardedRef}
        className={cn}
        type={input.type || type}
        disabled={disabled}
        readOnly={readonly}
        placeholder={placeholder}
        {...other}
      />
      {showCopyButton && (
        <div className={classes.copyIcon} onClick={() => copy(input.value)}>
          <SVGIcon
            width="16px"
            height="16px"
            name={copied ? 'checkmark' : 'copy'}
            className={classnames(copied ? classes.copied : classes.copy)}
          />
        </div>
      )}
    </div>
  );
});

Input.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['text', 'password', 'number', 'email']),
  cleanable: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  className: PropTypes.string,
  showCopyButton: PropTypes.bool
};

Input.displayName = 'Input';

export default Input;
